<p>base-time-navigable-page works!</p>
